import { combineReducers } from 'redux';

import { REQUEST_PARTNER_SHOPS, RECEIVE_PARTNER_SHOPS, FAILURE_PARTNER_SHOPS } from './constants';

const shops = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_PARTNER_SHOPS:
            return { ...state, [action.id]: action.response.payload };
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PARTNER_SHOPS:
            return true;
        case FAILURE_PARTNER_SHOPS:
        case RECEIVE_PARTNER_SHOPS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PARTNER_SHOPS:
            return action.response.message;
        case REQUEST_PARTNER_SHOPS:
        case RECEIVE_PARTNER_SHOPS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    shops,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/shop/reducer.js